<template>
  <div class="messenger-wrapper">
    <a
      href="https://m.me/janos.dunai.94"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Messenger Chat"
      class="messenger-btn"
    >
      <span class="tooltip">
        Írj nekem!
      </span>
      <svg
        width="39"
        height="39"
        viewBox="0 0 39 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="messenger-icon"
      >
        <circle
          cx="19.4395"
          cy="19.4395"
          r="19.4395"
          fill="#1E88E5"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 9.63934C0 4.29861 4.68939 0 10.4209 0C16.1524 0 20.8418 4.29861 20.8418 9.63934C20.8418 14.98 16.1524 19.2787 10.4209 19.2787C9.37878 19.2787 8.33673 19.1484 7.42487 18.8879L3.90784 20.8418V17.1945C1.56311 15.3708 0 12.6353 0 9.63934ZM8.85779 10.1604L11.463 13.0261L17.1945 6.90384L12.1143 9.76959L9.37885 6.90384L3.64734 13.0261L8.85779 10.1604Z"
          transform="translate(9.01854 10.3146)"
          fill="white"
        />
      </svg>
    </a>
  </div>
</template>

<script>
export default {
  name: 'TheHomeFbBusinessPage',
};
</script>

<style scoped>
.messenger-wrapper {
  position: fixed;
  right: 20px;
  bottom: 30px;
  z-index: 9999;
}

.messenger-btn {
  position: relative;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #0084ff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 18px rgba(0, 132, 255, 0.35);
  transition: all 0.3s ease;
  text-decoration: none;
}

.messenger-btn:hover {
  transform: scale(1.08);
}

.messenger-icon {
  width: 40px;
  height: 40px;
}

.tooltip {
  position: absolute;
  right: 75px;
  background: white;
  color: #333;
  padding: 10px 14px;
  border-radius: 10px;
  font-size: 14px;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  opacity: 0;
  visibility: hidden;
  transition: all 0.25s ease;
}

.messenger-btn:hover .tooltip {
  opacity: 1;
  visibility: visible;
}

@media (max-width: 768px) {
  .messenger-wrapper {
    right: 16px;
    bottom: 16px;
  }

  .messenger-btn {
    width: 56px;
    height: 56px;
  }

  .messenger-icon {
    width: 30px;
    height: 30px;
  }

  .tooltip {
    display: none;
  }
}
</style>
